export { default } from './TabsNavigation';
